import { api } from 'utils';

import {
  ClosedTicketsParams,
  FetchClosedTicketsApiResponse,
} from './ClosedTickets.types';

export function fetchClosedTicketsApi({ queryKey }: any) {
  const [, , params] = queryKey as [string, string, ClosedTicketsParams];

  return api().get<FetchClosedTicketsApiResponse>(
    '/endorsement/health-claims/closed-tickets',
    {
      params: {
        // Sent only when set, so an empty box is no filter rather than a
        // filter on the empty string.
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        category: params.category || undefined,
        reference: params.reference || undefined,
        first: params.first,
        rows: params.rows,
      },
    }
  );
}
